import { render, staticRenderFns } from "./BaseFormGroupTextareaTest.vue?vue&type=template&id=35fd5774"
import script from "./BaseFormGroupTextareaTest.vue?vue&type=script&lang=js"
export * from "./BaseFormGroupTextareaTest.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroupTextareaTest.vue?vue&type=style&index=0&id=35fd5774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports